import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import { adjustAssetUrl, useConfigurationMeta, useCsValue, } from "@plansoft-configuration-renderer/framework";
import { ImageZoom } from "./ImageZoom";
/**
 * Displays image for value
 *
 * @todo Check if misuse of {@linkcode CardMedia} lead to problems here. Seems to work
 * @param props
 * @returns
 */
export function ValueContentImage(props) {
    const value = useCsValue();
    const { baseUrl } = useConfigurationMeta();
    const { imageHeight, imageWidth, imageComponent = "picture", imageSxProps = {}, isZoomable = false, } = props;
    if (!value.image) {
        // display a placeholder with the same height
        return (_jsx(CardMedia, { component: Box, height: imageHeight, width: imageWidth, sx: imageSxProps }));
    }
    const imageUrl = adjustAssetUrl(value.image, baseUrl);
    return (_jsxs(Box, { sx: { position: "relative" }, children: [_jsx(CardMedia, { component: imageComponent, height: imageHeight, width: imageWidth, src: imageUrl, alt: value.value, sx: imageSxProps }), _jsx(ImageZoom, { isZoomable: isZoomable, imageUrl: imageUrl, imageAlt: value.value })] }));
}
//# sourceMappingURL=ValueContentImage.js.map